<template>
    <desktop-navbar>
        <div slot="main-nav" class="flex max-height justify-between items-center">
            <div class="flex max-height items-center">
                <a class="desktop-nav__br-logo p-r-lg">
                    <logo></logo>
                </a>
            </div>
            <div class="desktop-nav__user-icon flex items-center">
                <user-icon></user-icon>
            </div>
        </div>
    </desktop-navbar>
</template>

<script>
import Logo from '../logo'
import DesktopNavbar from '../templates/desktop-navbar';

export default {
    components: { Logo, DesktopNavbar },

    props: {
        isAuthenticated: Boolean,
    }
}
</script>
